import { useState } from 'react';

import { StyledCircularProgress } from './ActionButton.styles';
import { CoreButton } from '@youscience/core';

type ActionButtonProps = {
  onClick?: () => Promise<void> | void;
  busyText?: string;
} & React.ComponentPropsWithoutRef<typeof CoreButton>;

export const ActionButton = (props: ActionButtonProps) => {
  const { onClick, busyText, sx, ...otherProps } = props;

  const [isBusy, setIsBusy] = useState(false);

  const handleClick = async () => {
    if (isBusy) return;

    setIsBusy(true);

    if (!onClick) return;

    const result = onClick();

    if (result instanceof Promise) {
      result.finally(() => setIsBusy(false));
    } else {
      setIsBusy(false);
    }
  };

  return (
    <CoreButton
      {...(onClick ? { onClick: handleClick } : {})}
      {...otherProps}
      sx={{
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        ...sx,
      }}
      startIcon={isBusy ? <StyledCircularProgress size={15} /> : otherProps.startIcon}
    >
      {isBusy && busyText ? `${busyText}...` : otherProps.children}
    </CoreButton>
  );
};
